import gql from 'graphql-tag';

export const deleteAllUserDeviceMutation = gql`
  mutation deleteAllUserDeviceMutation($userId: ID!) {
    deleteAllUserDevices(userId: $userId) {
      success
    }
  }
`;
